import { ModalName } from "../types/modal";

export const GENERIC_MODALS = [ModalName.ADD, ModalName.UPDATE, ModalName.VIEW];
